var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69055 14C3.79512 14 4.69055 14.8954 4.69055 16C4.69055 17.1046 3.79512 18 2.69055 18C1.58598 18 0.690552 17.1046 0.690552 16C0.690552 14.8954 1.58598 14 2.69055 14ZM2.69055 7C3.79512 7 4.69055 7.8954 4.69055 9C4.69055 10.1046 3.79512 11 2.69055 11C1.58598 11 0.690552 10.1046 0.690552 9C0.690552 7.8954 1.58598 7 2.69055 7ZM2.69055 0C3.79512 0 4.69055 0.89543 4.69055 2C4.69055 3.10457 3.79512 4 2.69055 4C1.58598 4 0.690552 3.10457 0.690552 2C0.690552 0.89543 1.58598 0 2.69055 0Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDot);
export default __webpack_public_path__ + "static/media/actionDot.af561b76f3039d20684b9d518b15d635.svg";
export { ForwardRef as ReactComponent };